import isArrayLike from './is-array-like';
var contains = function (arr, value) {
    if (!isArrayLike(arr)) {
        return false;
    }
    return arr.indexOf(value) > -1;
};
export default contains;
//# sourceMappingURL=contains.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/contains.js
// module id = 80
// module chunks = 3